import type { MobileOrientation } from "@/lib/schemas/game";

export type DeviceOrientation = "portrait" | "landscape";

export function getDeviceOrientation(): DeviceOrientation | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const portraitQuery = window.matchMedia("(orientation: portrait)");
    return portraitQuery.matches ? "portrait" : "landscape";
  } catch {
    if (window.innerHeight >= window.innerWidth) {
      return "portrait";
    }
    return "landscape";
  }
}

export function isOrientationMismatch(
  preference: MobileOrientation,
  deviceOrientation: DeviceOrientation | null
): boolean {
  if (preference === "both" || deviceOrientation === null) {
    return false;
  }

  return preference !== deviceOrientation;
}

export function getOrientationPromptMessage(preference: MobileOrientation): string {
  if (preference === "landscape" || preference === "portrait") {
    return "Rotate to play";
  }

  return "";
}

export function shouldShowOrientationPrompt(
  preference: MobileOrientation,
  deviceOrientation: DeviceOrientation | null,
  isMobileGameContext: boolean
): boolean {
  if (!isMobileGameContext) {
    return false;
  }

  return isOrientationMismatch(preference, deviceOrientation);
}
